<template>
  <sup
    class="disclosure-superscript"
    :disclosure-superscript-anchor="anchor"
    :statistics="statistics"
  >{{ superScript }}</sup>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	props: ['anchor', 'statistics'],
	computed: {
		...mapGetters(['disclosureSuperscripts']),
		superScript() {
			let superscripts = '';
			if (this.disclosureSuperscripts) superscripts = this.disclosureSuperscripts[this.anchor] || '';
			return superscripts;
		}
	},
	watch: {
		statistics(newSta, oldSta) {
			if (newSta !== oldSta) this.$EventBus.$emit('additional-disclosure-mounted');
		}
	},
	beforeMount() {
		this.$EventBus.$emit('additional-disclosure-mounted');
	},
	unmounted() {
		this.$EventBus.$emit('additional-disclosure-mounted');
	}
};
</script>
<style>
sup.disclosure-superscript {
	font-size: 0.6428em; /* font size relative to parent */
	font-family: "Avenir Next LT W01 Demi",Arial,sans-serif;
	vertical-align: super;
	top: 0;
}
sup::after {
	content: '\00a0' !important;
    font-size: 1.6em !important;
    display: inline-block !important;
    height: 2px !important;
    vertical-align: bottom !important;
}
</style>
